import { atomWithStorage, createJSONStorage } from "jotai/utils";

import { SELECTED_ORGANISATION_ID } from "@/constants/browserMemory.constants";

const storage = createJSONStorage<number>(() => sessionStorage);
export const selectedOrganisationIdAtom = atomWithStorage<number>(
  SELECTED_ORGANISATION_ID,
  0,
  storage
);
